<template>
  <div>
    <div class="outdoor-pricelist-detail" v-if="!isModalLoading">
      <div v-if="brand" class="outdoor-pricelist-detail__row">
        <div class="subhead">Brand</div>
        <h1>{{brand}}</h1>
      </div>
      <div v-if="optDay" class="outdoor-pricelist-detail__row">
        <div class="subhead">Opt Day per Month</div>
        <h1>{{pluralize(optDay, 'Day')}}</h1>
      </div>
      <div v-if="minPeriod && minPeriodUnit" class="outdoor-pricelist-detail__row">
        <div class="subhead">Minimum Order Period</div>
        <h1>{{pluralize(minPeriod, minPeriodUnit)}}</h1>
      </div>
      <div v-if="leadTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Lead Time</span>
          <tooltip text="Lead Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 class="subhead">{{pluralize(leadTime, 'Day')}}</h1>
      </div>
      <div v-if="trailTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Trail Time</span>
          <tooltip text="Trail Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 class="subhead">{{pluralize(trailTime, 'Day')}}</h1>
      </div>
      <div v-if="reportTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Report Time</span>
          <tooltip text="Report Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 class="subhead">{{pluralize(reportTime, 'Day')}}</h1>
      </div>
      <div v-if="BASTTime" class="outdoor-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">BAST Time</span>
          <tooltip text="BAST Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 class="subhead">{{pluralize(BASTTime, 'Day')}}</h1>
      </div>
      <div class="outdoor-pricelist-detail__tnc">
       <h1 class="subhead">Terms & Conditions</h1>
       <ul v-if="terms">
        <li class="subhead" v-for="(term, index) in terms" :key="index">{{term}}</li>
       </ul>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";
import tooltip from '@/components/Tooltip';

export default {
  name: "adx-outdoor-placement-detail",
  components: {
    "a-loading": ALoadingPrimary,
    "tooltip": tooltip
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      brand: null,
      optDay: null,
      terms: [],
      minPeriod: null,
      minPeriodUnit: null,
      leadTime: null,
      trailTime: null,
      reportTime: null,
      BASTTime: null
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.busPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.brand = data.route.bus_brand_name;
        this.optDay = data.route.operation_day;
        this.terms = data.route.tnc;
        this.minPeriod = data.min_period;
        this.minPeriodUnit = data.min_period_unit;
        this.leadTime = data.lead_time;
        this.trailTime = data.trail_time;
        this.reportTime = data.report_time;
        this.BASTTime = data.bast_time;
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
